import mediaContentCarousel from "./mediaContentCarousel.js";
import carousel from "./carousel";
import chat from "./chat.js";
import demographicsChart from "./demographicsChart.js";
import viewsLastSevenDays  from './viewsLastSevenDays.js'
import carouselLoadingMedia from "./carouselLoadingMedia.js";
import contentLibraryManagement from "./contentLibraryManagement.js";
import portfolioWizardUploadManagement from "./portfolioWizardUploadManagement.js";
import visionBoardManagement from "./visionBoardManagement.js";
import videoPreviewHandler from "./videoPreviewHandler.js";
import appearanceMode from "./appearanceMode.js";
import stepperAppearance from "./stepperAppearance.js";
import themeWatcher from "./themeWatcher.js";
import profileWizardVideos from "./profileWizardVideos.js";
import portfolioUploadManagement from "./portfolioUploadManagement.js";

Alpine.data("mediaContentCarousel", mediaContentCarousel);
Alpine.data("carousel", carousel);
Alpine.data("chat", chat);
Alpine.data("demographicsChart", demographicsChart);
Alpine.data("viewsLastSevenDays", viewsLastSevenDays);
Alpine.data("carouselLoadingMedia", carouselLoadingMedia);
Alpine.data("contentLibraryManagement", contentLibraryManagement);
Alpine.data("portfolioWizardUploadManagement", portfolioWizardUploadManagement);
Alpine.data("visionBoardManagement", visionBoardManagement);
Alpine.data("videoPreviewHandler", videoPreviewHandler);
Alpine.data("appearanceMode", appearanceMode);
Alpine.data("stepperAppearance", stepperAppearance);
Alpine.data("themeWatcher", themeWatcher);
Alpine.data("profileWizardVideos", profileWizardVideos);
Alpine.data("portfolioUploadManagement", portfolioUploadManagement);
